// @ts-check

import { Link } from 'gatsby'
import React from 'react'
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebookF, FaLinkedinIn, FaAward } from 'react-icons/fa'

/**
 * @returns {React.JSX.Element}
 */
const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footerMain">
      {/* Main footer content */}
      <div className="container-custom">
        <div className="footerGrid">
          {/* Company Info */}
          <div>
            <div className="footerLogoWrapper">
              <div className="logoIcon"><span className="textWhite fontBold">P</span></div>
              <div><div className="fontSemibold">ProSource</div><div className="textXs textGray400">Home Inspection</div></div>
            </div>
            <p className="footerDescription">Your trusted partner in making informed real estate decisions. Thorough, professional home inspections backed by 15+ years of experience.</p>
            <div className="footerCertified"><FaAward size={20} /><span>Licensed & Certified</span></div>
          </div>

          {/* Quick Links */}
          <div><h3 className="footerTitle">Quick Links</h3>
            <ul className="footerLinks">
              <li><Link to="/about/" className="footerLink">About Us</Link></li>
               <li><Link to="/services/" className="footerLink">Our Services</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div><h3 className="footerTitle">Services</h3>
            <ul className="footerLinks">
              <li><span className="footerLink">Pre-Purchase Inspection</span></li>
              <li><span className="footerLink">Radon Testing</span></li>
              <li><span className="footerLink">Thermal Imaging</span></li>
              <li><span className="footerLink">Sewer Scope Inspections</span></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="footerTitle">Contact Us</h3>
            <ul className="flexCol gap1">
              <li className="footerContactItem"><FaPhone className="text-blue-400 flex-shrink-0" /><a href="tel:5035551234" className="linkGray">(503) 555-1234</a></li>
              <li className="footerContactItem"><FaEnvelope className="text-blue-400 flex-shrink-0" /><a href="mailto:info@prosourcehomeinspection.com" className="linkGraySmall">info@prosourcehomeinspection.com</a></li>
              <li className="footerContactItem"><FaMapMarkerAlt className="text-blue-400 flex-shrink-0" /><span className="linkGraySmall">Serving Olympia, Lacey & the I-5 Corridor</span></li>
            </ul>
            <div className="footerHoursWrapper"><p className="textXs textGray400"><span className="footerBold">Hours:</span> Mon-Sun: 7AM - 7PM</p></div>
            <div className="footerSocials">
              <a href="#" className="linkText textWhite" aria-label="Facebook"><FaFacebookF size={16} /></a>
              <a href="#" className="linkText textWhite" aria-label="LinkedIn"><FaLinkedinIn size={16} /></a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footerBottomBorder">
        <div className="containerCustom flexCol gap1 items-center justify-center text-sm text-gray-500">
          <p>&copy; {currentYear} ProSource Home Inspection. All rights reserved.</p>
          <div className="flexCenter gap1-5">
            <Link to="/privacy/" className="footerBottomLink">Privacy Policy</Link>
            <Link to="/sitemap.xml" className="footerBottomLink">Sitemap</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
